import { Box } from "@raca2022/uikit";
import styled from "styled-components";

export const Container = styled(Box)`
  width: 100%;
  max-width: 1920px;
  padding: 7.5vw 10vw 0px;
  display: flex;
  justify-content: space-between;
  @media only screen and (min-width: 1920px) {
    padding: 100px 230px 0px;
  }
`;
export const BoxText = styled(Box)`
  padding-top: 40px;
  h1 {
    font-family: PoppinsBold;
    font-weight: 700;
    font-size: 2.6vw;
    line-height: 110%;
    color: #144456;
    margin-bottom: 48px;
  }
  p {
    font-weight: 500;
    font-size: 1.25vw;
    line-height: 110%;
    color: #8094ae;
    font-family: PoppinsMedium;
    width: 100%;
    max-width: 710px;
    margin-bottom: 24px;
  }
  button {
    margin-top: 40px;
    background: #009768;
    box-shadow: 2px 4px 6px rgba(15, 46, 57, 0.23);
    border-radius: 10px;
    padding: 18px 99px;
    border: none;
    outline: none;
    font-weight: 600;
    font-size: 18px;
    line-height: 110%;
    color: #ffffff;
    font-family: PoppinsSemiBold;
  }
  @media only screen and (min-width: 1920px) {
    h1 {
      font-size: 50px;
    }
    p {
      font-size: 24px;
    }
  }
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

export const BoxImg = styled(Box)`
  h1 {
    display: none;
  }
  img {
    max-width: 100%;
  }
  button , p{
    display: none;
  }
  @media only screen and (max-width: 1024px) {
    display: flex;
    width: 100%;
    max-width: 100%;
    position: relative;
    flex-wrap: wrap;
    justify-content: flex-end;
    img {
      margin-right: 50px;
      margin-bottom: 20px;
    }
    h1 {
      display: flex;
      flex-direction: column;
      font-size: 40px;
      color: #144456;
      font-weight: 700;
      line-height: 110%;
      font-family: PoppinsBold;
      justify-content: flex-start;
      margin-left: 18px;
      transform: rotateZ(90deg) translateY(-180px) translateX(50%);
      top: 0px;
      right: 0px;
      display: inline-block;
      width: fit-content;
      height: fit-content;
      top: 0%;
      position: absolute;
      display: block ruby;
      width: max-content;
    }
    p {
      font-weight: 500;
      font-size: 12px;
      line-height: 110%;
      text-align: center;
      color: #8094ae;
      margin-top: 10px;
      display: block;
    }
    button {
      margin: auto;
      margin-top: 26px;
      background: #009768;
      box-shadow: 2px 4px 6px rgba(15, 46, 57, 0.23);
      border-radius: 5px;
      font-weight: 600;
      font-size: 10px;
      line-height: 110%;
      width: 25vw;
      min-width: 108px;
      max-width: 207px;
      max-height: 57px;
      height: 6.3vw;
      min-height: 27px;
      color: #fff;
      border: none;
      outline: none;
      display: block;
      margin-bottom: 42px;
    }
  }
  @media only screen and (max-width: 540px) {
    img {
      max-width: fit-content;
      height: 420px;
      margin-right: 50px;
      margin-bottom: 20px;
    }
  }
`;
